import React, { useEffect } from "react";
import { C } from "../core/constants";
import { useI18n } from "../features/i18n/LocaleProvider";
import Button from "./Button";
import GlassCard from "./GlassCard";

export default function FreeQuotaConfirmPopup({
  open,
  title,
  message,
  note,
  confirmLabel,
  cancelLabel,
  onClose,
  onConfirm,
  acc,
}) {
  const { t } = useI18n();

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      onClick={() => onClose?.()}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 120,
        background: "rgba(3,6,20,0.72)",
        backdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
    >
      <div onClick={(event) => event.stopPropagation()} style={{ width: "min(540px, 100%)" }}>
        <GlassCard style={{ padding: 24, border: `1px solid ${acc.secondary}66` }} glow accent={acc.secondary}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12, marginBottom: 14 }}>
            <div>
              <div style={{ fontSize: 11, color: C.textMuted, letterSpacing: "0.1em", marginBottom: 6 }}>{t("free_quota_popup_badge_available")}</div>
              <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 30, color: C.textPrimary, lineHeight: 1.1 }}>
                {title}
              </div>
            </div>
            <button
              type="button"
              onClick={() => onClose?.()}
              aria-label={t("aria_close")}
              style={{
                border: "none",
                background: "transparent",
                color: C.textMuted,
                cursor: "pointer",
                fontSize: 24,
                lineHeight: 1,
                padding: 0,
              }}
            >
              ×
            </button>
          </div>

          <p style={{ fontSize: 14, color: C.textSecondary, lineHeight: 1.7, marginBottom: note ? 14 : 18 }}>{message}</p>
          {note ? (
            <div style={{ marginBottom: 18, padding: "10px 12px", borderRadius: 12, border: `1px solid ${acc.secondary}33`, background: `${acc.secondary}10`, color: C.textMuted, fontSize: 12, lineHeight: 1.6 }}>
              {note}
            </div>
          ) : null}
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", flexWrap: "wrap" }}>
            <Button variant="outline" acc={acc} onClick={() => onClose?.()}>
              {cancelLabel}
            </Button>
            <Button variant="primary" acc={acc} onClick={() => onConfirm?.()}>
              {confirmLabel}
            </Button>
          </div>
        </GlassCard>
      </div>
    </div>
  );
}
